// removed by extract-text-webpack-plugin
module.exports = {"logo":"_2hwuCQJCE5lUHdU6kUE4R9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.less
// module id = 215
// module chunks = 0